export const excludedDigits = [
  1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 1011, 1035, 1040,
  1099, 1142, 1151, 1235, 1237, 1238, 1978, 2020, 2021, 2022, 2023, 2024, 2025,
  2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2057, 2066, 2130, 2158,
  2255, 2265, 3014, 3025, 3665, 4221, 4531, 5132, 5252, 5286, 5307, 5308, 5341,
  5342, 5497, 5498, 6070, 6119, 6445, 6488, 6597, 6612, 6734, 7820, 7821, 9510,
  9555, 22560, 30636, 48639, 391801,
];
